'use client';

import { useEffect } from 'react';
import { AppUserFullInfo } from '../userinfo/types';
import {
  setClientTraceUserId,
  setDataDogUser,
  isLocalTracingEnabled,
} from '@bts-web/utils-next-infrastructure';

const SetDatadogUser = ({ userData }: { userData: AppUserFullInfo }) => {
  useEffect(() => {
    if (userData.id) {
      setDataDogUser(userData.id);

      if (isLocalTracingEnabled()) {
        setClientTraceUserId(userData.id);
      }
    }
  }, [userData.id]);

  return null;
};

export { SetDatadogUser };
